<template>
  <v-container>
    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :timeout="2500"
      top
    >
      {{ snackbar.message }}
    </v-snackbar>

    <v-card v-if="loading">
      <v-row  align="center" justify="center">
        <v-col style="text-align:center;">
          <v-progress-circular indeterminate size="32" color="primary"></v-progress-circular>
          <div>加载中...</div>
        </v-col>
      </v-row>
    </v-card> 

    <v-card v-else-if="sendSuccess" dense>
      <v-row>
        <v-col cols="12" style="padding: 32px; text-align: center;">
          <v-icon color="success" size="56">mdi-check-circle</v-icon>
          <div style="font-size: 24px; font-weight: bold; margin-top: 16px;">发送成功</div>
          <div style="margin-top: 8px; color: #666;">邮件已经成功发送。</div>
          <div style="margin-top: 24px;">
            <v-btn color="primary" @click="toMailList">返回邮件列表</v-btn>
          </div>
        </v-col>
      </v-row>
    </v-card>

    <v-card v-else dense>
      

      <v-row> 
        <v-col style="padding: 0px; padding-left: 18px; padding-top: 4px;">
          <div style="align:center;cursor:pointer;padding:2px" @click="goBack">
            <v-icon>mdi-account</v-icon>关闭
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col style="padding: 8px" clos="12">
          <v-card-text style="padding: 4px; padding-left: 12px;font-weight: bold;">
            <v-text-field 
            v-model="subject" 
            dense 
            outlined
          />
          </v-card-text>
        </v-col>
      </v-row>
      <v-row>
        <v-col style="padding: 8px" clos="6">
          <v-card-text style="padding: 4px; padding-left: 12px;">
            <strong>{{this.to_addr}} </strong> &lt;{{this.to_addr}}&gt;
          </v-card-text>
          <v-card-text style="padding: 4px; padding-left: 12px;">回复到 <strong>{{this.from_name}}</strong> &lt;{{this.from_addr}} &gt;</v-card-text>
        </v-col>
        <v-col style="padding: 8px; padding-right: 20px;" clos="6">
          <v-card-text style="padding: 4px; text-align: right;">
            {{this.mail_time}}
          </v-card-text>
        </v-col>
      </v-row>
      
      <!-- 回复内容编辑区域 -->
      <v-row>
        <v-col style="padding: 12px" clos="12">
          <quill-editor
            v-model="replyBody"
            :options="editorOptions"
          />
        </v-col>
      </v-row>

      <!-- 添加附件 -->
      <div v-show="has_attach">
        <v-card-text>附件列表</v-card-text>
        <div style="padding: 8px; padding-left: 20px; padding-right: 20px;" v-for="(data, index) in attach_list" :key="index">
          <a :href="data.url">{{ data.filename }}</a>
        </div>
      </div>

      <!-- 回复操作按钮 -->
      <v-row>
        <v-col style="padding: 16px" clos="12">
          <v-btn @click="sendReply" color="primary" :disabled="sending" :loading="sending">发送回复</v-btn>
          <v-btn @click="this.goBack" color="secondary" style="margin-left: 24px;">取消</v-btn>
        </v-col>
      </v-row>
    </v-card>

  </v-container>
</template>

<script>

import axios from 'axios';

export default {
  data() {
    return {
      sending:false,
      loading: true,
      sendSuccess: false,
      replyBody: '',  // 用于存储回复内容
      subject: '邮件标题', // 原始邮件标题
      from_name: '发件人', // 发件人名称
      from_addr: 'from@example.com', // 发件人地址
      to_addr: 'to@example.com', // 收件人地址
      mail_time: '2025-10-12 10:00', // 邮件时间
      has_attach: false, // 是否有附件
      attach_list: [{ filename: 'example.txt', url: '/attachments/example.txt' }], // 附件列表
      ref_id: '123456789' // 邮件ID
      ,
      snackbar: {
        show: false,
        message: '',
        color: 'error'
      },
      editorOptions: {
          theme: 'snow',
          // modules: {
          //   toolbar: [
          //     ['bold', 'italic', 'underline'],
          //     [{ 'color': [] }]
          //   ]
          // }
      },

    };
  },
  mounted: function(){
    //alert("OK");
    let alt = 2;
    if (alt==1) return;
    axios.defaults.baseURL = process.env.VUE_APP_BASEURL;
    axios.get('/api/getmail?mailid='+this.$route.params.mailid ).then( response=>{ 
      console.log("/getmail", response);
      let ajData = response.data.data;
      this.subject = "Re: " + ajData.subject;
      this.from_addr = ajData.from_addr;
      this.to_addr = ajData.to_addr;
      this.mail_time = ajData.mail_time;
      this.body = ajData.body;
      this.from_name = ajData.from_name;
      this.ref_id = ajData.ref_id;
      this.attach_list = ajData.msg_att;
      if ( this.attach_list && this.attach_list.length > 0)
      {   
        this.has_attach = true ;
        for(let item of this.attach_list){
          item.url = '/api/getmailatt?mailid='+this.ref_id+"&attid="+item.fid;
        }
      }
      let header = "<br><br>On " + this.mail_time + " " + this.from_addr + " wroted:";
      this.replyBody = header + '<br/>-----------------------------------------------<br/>' + this.body;
      //for(const i in rep)
      this.loading = false;
    }).catch(err=>{
      console.log(err);
    });
  }
  ,
  async created(){
    axios.defaults.baseURL = process.env.VUE_APP_BASEURL;
    await axios.get('/api/profile' ).then(
      response=>{
        console.log("profile ", response);
        if (response.status==200 && response.data.code==200){
            console.log("ok");
            this.logininfo = response.data.data;
        }else{
          window.location = '/login';
        }
      }
    )
    .catch(err=>{
      window.location = '/login';
      console.log(err);
    });
  },

  methods: {
    toMailList() {
      this.$router.push({ name: "vEmails", params: { msg: "emails" } });
    },

    showDomainNotFoundError() {
      this.snackbar.message = "发送域名不存在";
      this.snackbar.color = "error";
      this.snackbar.show = true;
    },

    showPasswordError() {
      this.snackbar.message = "密码错误";
      this.snackbar.color = "error";
      this.snackbar.show = true;
    },

    goBack() { 
      this.$router.go(-1);
    },

    async sendReply() {
      this.sending = true;
      try {
        // 构造请求数据
        const postData = {
          from: this.to_addr,      // 发件人
          to: this.from_addr,          // 收件人
          subject: this.subject, // 可编辑主题
          body: this.replyBody       // 富文本 HTML 或纯文本
        };

        // 发送POST请求
        axios.defaults.baseURL = process.env.VUE_APP_BASEURL;
        const response = await axios.post("/api/SendMsgEx", postData, {
          headers: { "Content-Type": "application/json" }
        });

        // 处理返回结果
        if (response.data.code === 404) {
          this.showDomainNotFoundError();
        } else if (response.data.code === 502) {
          this.showPasswordError();
        } else if (response.data.code === 200 && response.data.message === "OK") {
          this.sendSuccess = true;
        } else {
          console.log("邮件发送失败: " + response.data.message);
        }
      } catch (err) {
        console.error("发送邮件错误:", err);
        if (err.response && err.response.status === 404) {
          this.showDomainNotFoundError();
        } else {
          console.log("邮件发送异常，请检查网络或接口");
        }
      } finally {
        this.sending = false;
      }
    }
  
  }
};
</script>
